import { PageHeading } from '@quad/bootstrap-react';
import { Container } from 'react-bootstrap';
import ScrollPageContent from '../../areas/shared/ScrollPageContent';
import ApplicationsTable from './ApplicationsTable';
import { IApplication } from '../../api/models';

export interface ApplicationSearchResultsProps {
    data: IApplication[];
}

const ApplicationSearchResults = ({ data }: ApplicationSearchResultsProps) => {
    return (
        <>
            <ScrollPageContent>
                <PageHeading>
                    <div className="col">
                        <h1>
                            <i className="fa fa-search"></i> Search Results
                        </h1>
                    </div>
                </PageHeading>
                <Container>
                    <ApplicationsTable data={data} isLoading={false} />
                </Container>
            </ScrollPageContent>
        </>
    );
};

export default ApplicationSearchResults;
